// extracted by mini-css-extract-plugin
export var linkedin = "linkedInButtonStyle-module--linkedin--29dRY";